
const GetStartup = () => {
  const benefits = [
    {
      icon: "ri-vote-line",
      title: "Voting Power",
      description: "Vote on which projects receive funding and support"
    },
    {
      icon: "ri-community-line", 
      title: "Community Access",
      description: "Join exclusive discussions and connect with dreamers"
    },
    {
      icon: "ri-trophy-line",
      title: "Success Rewards",
      description: "Benefit from the success of funded projects"
    },
    {
      icon: "ri-rocket-line",
      title: "Early Access",
      description: "Get first access to new features and opportunities"
    }
  ];

  return (
    <section className="py-24 bg-gradient-to-b from-blue-900 via-blue-950 to-black">
      <div className="container mx-auto px-6">
        <div className="max-w-6xl mx-auto">
          {/* Section Header */}
          <div className="text-center mb-16">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-white/10 rounded-full mb-8">
              <i className="ri-coins-line text-2xl text-white"></i>
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
              Get $Startup
            </h2>
            <p className="text-xl text-white/80 font-light max-w-2xl mx-auto">
              Join the movement and help turn dreams into reality
            </p>
            <div className="w-24 h-1 bg-white mx-auto mt-8"></div>
          </div>

          {/* Token Info */}
          <div className="bg-white/5 rounded-2xl p-8 border border-white/10 mb-16">
            <div className="grid md:grid-cols-2 gap-12 items-center">
              <div>
                <h3 className="text-3xl font-bold text-white mb-6">
                  $Startup Token
                </h3>
                <p className="text-lg text-white/80 font-light leading-relaxed mb-8">
                  The $Startup token is more than just cryptocurrency — it's your key to 
                  participating in a global community dedicated to making dreams come true.
                </p>
                <div className="space-y-4">
                  <div className="flex items-center">
                    <i className="ri-check-line text-white mr-3"></i>
                    <span className="text-white/90">Community governance rights</span>
                  </div>
                  <div className="flex items-center">
                    <i className="ri-check-line text-white mr-3"></i>
                    <span className="text-white/90">Project funding participation</span>
                  </div>
                  <div className="flex items-center">
                    <i className="ri-check-line text-white mr-3"></i>
                    <span className="text-white/90">Exclusive community access</span>
                  </div>
                </div>
              </div>
              
              <div className="text-center">
                <div className="inline-flex items-center justify-center w-32 h-32 bg-white/10 rounded-full mb-6">
                  <i className="ri-coins-line text-5xl text-white"></i>
                </div>
                <div className="text-2xl font-bold text-white mb-2">$Startup</div>
                <div className="text-white/60">Coming Soon</div>
              </div>
            </div>
          </div>

          {/* Benefits Grid */}
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
            {benefits.map((benefit, index) => (
              <div key={index} className="text-center group">
                <div className="inline-flex items-center justify-center w-16 h-16 bg-white/10 rounded-full mb-6 group-hover:bg-white/20 transition-all duration-300">
                  <i className={`${benefit.icon} text-2xl text-white`}></i>
                </div>
                <h4 className="text-xl font-semibold text-white mb-4">
                  {benefit.title}
                </h4>
                <p className="text-white/80 font-light leading-relaxed">
                  {benefit.description}
                </p>
              </div>
            ))}
          </div>

          {/* CTA */}
          <div className="text-center">
            <div className="bg-white/5 rounded-2xl p-8 border border-white/10 inline-block">
              <h3 className="text-2xl font-bold text-white mb-4">
                Ready to Join?
              </h3>
              <p className="text-white/80 font-light mb-6 max-w-md">
                Be among the first to get $Startup tokens when they launch
              </p>
              <button className="group bg-white text-black px-8 py-4 rounded-full font-semibold text-lg hover:bg-blue-100 transition-all duration-300 transform hover:scale-105 hover:shadow-2xl whitespace-nowrap cursor-pointer">
                Get Notified
                <i className="ri-notification-line ml-2 group-hover:animate-pulse"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GetStartup;
